module.exports = "/images/vendor/flag-icon-css/flags/4x3/ga.svg?29f203bb2828c1aed048b446c8abb0ae";